import "./Loading.scss";

const Loading = () => {
  return (
    <div className="loading">
      <div></div>
    </div>
  );
};

export default Loading;
